import { createContext, useContext, useState, useCallback, useRef } from 'react';
import { getMeasuresListWithCancelToken } from '../config/services/measures';

export const MeasureListContext = createContext();
export function MeasureListContextProvider({
  children,
}) {
  const measureListRef = useRef({});
  const requestRef = useRef({});
  const fetchMeasureListByDatasetId = async (datasetId) => {
    if (!datasetId) return;
    if (measureListRef.current[datasetId]) {
      return measureListRef.current[datasetId];
    }
    if (requestRef.current[datasetId]) {
      do {
        await new Promise(resolve => setTimeout(resolve, 100));
      } while (requestRef.current[datasetId] && !measureListRef.current[datasetId]);
      return measureListRef.current[datasetId];
    }
    const [cancelToken, request] = getMeasuresListWithCancelToken({ dataSetId: datasetId });

    requestRef.current[datasetId] = request;

    const res = await request();

    if (!res || res?.result.length === 0) {
      return;
    };

    const measures = res?.result;

    measureListRef.current[datasetId] = measures;

    delete requestRef.current[datasetId];
    return measures;
  };

  const addMeasureListByDataset = useCallback((datasetId, measures) => {
    if (!datasetId || measureListRef.current[datasetId]) return;
    measureListRef.current[datasetId] = measures;
  }, []);

  return (
    <MeasureListContext.Provider value={{ measureListByDataset: measureListRef.current, fetchMeasureListByDatasetId, addMeasureListByDataset }}>
      {children}
    </MeasureListContext.Provider>
  )
}

export function useMeasureListContext() {
  const context = useContext(MeasureListContext);
  if (context === undefined) {
    throw new Error('useMeasureListContext must be used within a MeasureListContextProvider');
  }
  return context;
};